module.exports = __webpack_public_path__ + "86310ad95744af9e59613830f85d7a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/drums-button.png
// module id = 37
// module chunks = 0